export enum CostActions {
  Reset = "reset",
  Fetchcosts = "fetchcosts",
  FetchEconomyDefaultOptions = "fetchEconomyDefaultOptions",
  FetchCost = "fetchCost",
  AddCost = "addCost",
  EditCost = "editCost",
}
